module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/personal-34932e67631614fcb7c203fd34788a87.png";